/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 */
export const CategorizationState = {
    VALID: 'VALID',
    ONCOMING: 'ONCOMING',
    EXPIRED: 'EXPIRED'
} as const;
export type CategorizationState = typeof CategorizationState[keyof typeof CategorizationState];

